import { useEffect, useState } from "react";
import { Search, X } from "lucide-react";
import { api } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { rupiah } from "@/lib/format";

export const MemberSearch = ({ value, onSelect, testId = "member-search" }) => {
  const [q, setQ] = useState("");
  const [results, setResults] = useState([]);

  useEffect(() => {
    if (q.trim().length < 2) { setResults([]); return undefined; }
    const t = setTimeout(() => {
      api.get("/members", { params: { q, status: "aktif" } }).then((r) => setResults(r.data.slice(0, 8))).catch(() => setResults([]));
    }, 250);
    return () => clearTimeout(t);
  }, [q]);

  if (value) {
    return (
      <div className="rounded-2xl border-2 border-primary/40 bg-primary/5 p-4 flex items-start gap-3" data-testid={`${testId}-selected`}>
        <div className="h-11 w-11 rounded-full bg-primary text-primary-foreground grid place-items-center font-heading font-bold shrink-0">{value.name[0]}</div>
        <div className="min-w-0 flex-1">
          <p className="font-semibold truncate" data-testid={`${testId}-selected-name`}>{value.name}</p>
          <p className="font-mono text-xs text-muted-foreground">{value.nik}{value.resort_name ? ` · Resort ${value.resort_name}` : ""}{value.loan_no ? ` · ${value.loan_no}` : ""}</p>
          <p className="text-xs mt-1">Saldo simpanan: <span className="font-mono font-semibold" data-testid={`${testId}-selected-balance`}>{rupiah(value.savings_balance)}</span></p>
        </div>
        <button type="button" onClick={() => { onSelect(null); setQ(""); }} className="h-10 w-10 grid place-items-center rounded-full hover:bg-muted" data-testid={`${testId}-clear`} aria-label="Ganti anggota">
          <X className="h-4 w-4" />
        </button>
      </div>
    );
  }

  return (
    <div className="relative">
      <Search className="absolute left-4 top-1/2 -translate-y-1/2 h-5 w-5 text-muted-foreground" />
      <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Cari NIK atau nama anggota..." className="h-14 pl-12 text-base rounded-2xl" data-testid={`${testId}-input`} inputMode="search" />
      {results.length > 0 && (
        <div className="absolute z-20 mt-2 w-full rounded-2xl border bg-popover shadow-xl overflow-hidden" data-testid={`${testId}-results`}>
          {results.map((m) => (
            <button type="button" key={m.nik} onClick={() => { onSelect(m); setResults([]); }} className="w-full text-left px-4 py-3 hover:bg-muted flex justify-between gap-3 min-h-[52px]" data-testid={`${testId}-result-${m.nik}`}>
              <span className="min-w-0"><span className="block font-medium truncate">{m.name}</span><span className="block font-mono text-xs text-muted-foreground">{m.nik}{m.resort_name ? ` · ${m.resort_name}` : ""}</span></span>
              <span className="font-mono text-xs text-muted-foreground self-center">{rupiah(m.savings_balance)}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
